module.exports = __webpack_public_path__ + "static/media/GG.6d36584f.svg";